import { render } from "./KebeleMapping.vue?vue&type=template&id=32dffa3a&scoped=true"
import script from "./KebeleMapping.vue?vue&type=script&lang=js"
export * from "./KebeleMapping.vue?vue&type=script&lang=js"

import "./KebeleMapping.vue?vue&type=style&index=0&id=32dffa3a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32dffa3a"]])

export default __exports__